<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.PhoneNo" placeholder="手机号码">
				<span slot="prepend">手机号码</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.ChargeCardNo" placeholder="充电卡号">
				<span slot="prepend">充电卡号</span>
				</Input>
			</FormItem>
			<FormItem label="充电卡状态:" :label-width="100" prop="trackName">
				<Select placeholder="充电卡状态" style="width: 200px;" v-model="formInline.Status">
					<Option :value='-1'>全部</Option>
					<Option :value='0'>正常</Option>
					<Option :value='1'>锁定</Option>
					<Option :value='256'>挂失</Option>
					<Option :value='516'>注销</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
			<FormItem style='float: right;'>
				<Button type="success" @click="openAddGroupMember('add')" v-if="hasWidgets('add')">会员新增</Button>
			</FormItem>
		</Form>
		<Table class="tableExtend" :columns="columns1" :data="data1" :height="tableHeight" ref="tableData" size="small"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getGroupInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal v-model="modal2.ifShow" :title="modal2.Title" width="40%" :mask-closable="false" :closable="false">
			<!--集团电卡添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal2.type=='add'||modal2.type=='up'"
				ref="chargeCardForm" :model="chargeCardInfo" :label-width="120">
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="会员ID:" prop="GroupId">
						<Input :disabled='true' v-model="chargeCardInfo.GroupId" placeholder="会员ID"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="电卡编号/VIN" prop="CardNo">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.CardNo"
							placeholder="输入电卡编号/VIN"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col span=24>
					<FormItem label="验证模式:" prop="VerifyMode">
						<i-switch :true-value='1' :false-value='0' v-model="VerifyMode1" size="large" style="margin-left: 10%;">
							<span slot="open">密码</span>
							<span slot="close">密码</span>
						</i-switch>
						<i-switch :true-value='1' :false-value='0' v-model="VerifyMode2" size="large" style="margin-left: 10%;">
							<span slot="open">车牌</span>
							<span slot="close">车牌</span>
						</i-switch>
						<i-switch :true-value='1' :false-value='0' v-model="VerifyMode3" size="large" style="margin-left: 10%;">
							<span slot="open">VIN</span>
							<span slot="close">VIN</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row> -->
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem prop="StationArray" label="限制场站:">
						<Select filterable :max-tag-count='1' placeholder="限制场站" multiple v-model="chargeCardInfo.StationArray">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in StationList" :value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="车牌号:" prop="CarNo">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.CarNo" placeholder="输入车牌号"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col span=12>
					<FormItem label="VIN码" prop="CarVin">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.CarVin" placeholder="输入VIN码"></Input>
					</FormItem>
					</Col>
				<Col span=12>
				<FormItem label="密码" prop="Password">
					<Input :disabled="modal2.canInput" v-model="chargeCardInfo.Password" placeholder="输入密码"></Input>
				</FormItem>
				</Col>
				</Row> -->
				<!-- <Row>
					<Col span=12>
					<FormItem label="建档人" prop="Creator">
						<Input :disabled='true' v-model="chargeCardInfo.Creator" placeholder="建档人"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="建档时间" prop="CreateTime">
						<Input :disabled='true' v-model="chargeCardInfo.CreateTime" placeholder="建档时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row>
					<Col span=12>
					<FormItem label="修改人" prop="Modifier">
						<Input :disabled='true' v-model="chargeCardInfo.Modifier" placeholder="修改人"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="修改时间" prop="ModifyTime">
						<Input :disabled='true' v-model="chargeCardInfo.ModifyTime" placeholder="修改时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<Row :gutter="24">
					<Col span=24>
					<FormItem label="备注" prop="Remark">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.Remark" placeholder="输入备注"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal2.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk2('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk2('add')">添加</Button>
			</div>
			<div v-if="modal2.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk2('cancle')" size="large">取消</Button>
				<Button type="success" @click="modalOk2('up')" size="large">修改</Button>
			</div>
		</Modal>
		<!--添加会员modal-->
		<GroupAddMember @handleSubmit="handleSubmit" ref="GroupAddMember"></GroupAddMember>
		<!--充值modal-->
		<GroupDeposit @handleSubmit="handleSubmit" ref="GroupDeposit"></GroupDeposit>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './GroupMemberInfoComponent/GroupMemberInfoExpand.vue';
	import GroupDeposit from './GroupMemberInfoComponent/GroupDeposit.vue';
	import GroupAddMember from './GroupMemberInfoComponent/GroupAddMember.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			GroupDeposit,
			GroupAddMember
		},
		data() {
			const validateStationArray = (rule, value, callback) => {
				if (value.length == 0) {
					callback(new Error('请选择场站'));
				} else {
					callback();
				}
			};
			return {
				getGroupInfoUrl: webapi.base_api_url + '/Member/GetGroupInfo',
				//添加充电卡信息
				chargeCardInfo: {
					GroupId: '',
					CardNo: '',
					VerifyMode: 1,
					Password: '',
					CarNo: '',
					CarVin: '',
					StationList: '',
					Remark: '',
					StationArray: []
				},
				//model2 控制 充电卡
				modal2: {
					Title: "充电卡添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				//充电卡规则
				ruleInline: {
					CardNo: [{
						required: true,
						message: '请输入编号',
						trigger: 'blur',
					}, ],
					StationArray: [{
						validator: validateStationArray,
						trigger: 'blur',
					}],
					CarNo: [{
						required: true,
						message: '请输入车牌',
						trigger: 'blur',
					}]
				},
				tableHeight: "650",
				BreadcrumbList: ['集团会员', '>>', '会员信息'],
				formInline: {
					MemberName: '',
					PhoneNo: '',
					ChargeCardNo: '',
					Status: -1
				},
				//table标题数据
				columns1: [{
						type: 'expand',
						width: 30,
						render: (h, params) => {
							const _this = this
							return h(expandRow, {
								props: {
									row: params.row
								},
								on: {
									// 子组件$emit传递函数
									upCard(GroupId, CardNo) {
										console.log(GroupId + "----" + CardNo)
										_this.openAddChargeCar("up", GroupId, CardNo);
									},
									upData(GroupId, CardNo) {
										_this.handleSubmit();
									},
								}
							})
						}
					},
					{
						title: '会员头像',
						key: 'Headimgurl',
						minWidth: 80,
						render: (h, params) => {
							let arr = [];
							if (params.row.Headimgurl == "" || params.row.Headimgurl == undefined) {
								arr.push(h('div', "未上传"))
							} else {
								arr.push(
									h('div', [
										h('img', {
											style: {
												width: "24px",
												height: "24px",
												verticalAlign: "middle",
												borderRadius: "50%"
											},
											attrs: {
												src: /http.*/i.test(params.row.Headimgurl) ? params.row.Headimgurl : webapi.base_api_url + params.row.Headimgurl
											}
										})
									])
								)
							}
							return arr;
							// return h('div', [
							// 	h('img', {
							// 		style: {
							// 			width: "30px",
							// 			verticalAlign: "middle"
							// 		},
							// 		attrs: {
							// 			src: params.row.Headimgurl
							// 		}
							// 	})
							// ])
						}
					},
					// , {
					// 	title: '集团ID',
					// 	key: 'GroupId',
					// 	width: '260',
					// }, 
					{
						title: '集团名称',
						key: 'GroupName',
						minWidth: 150,
					},
					{
						title: '手机号码',
						key: 'PhoneNo',
						minWidth: 150,
					},
					{
						title: '账户余额(元)',
						key: 'Account',
						minWidth: 120,
					},
					{
						title: '充值总金额(元)',
						key: 'RechargeAccount',
						minWidth: 120,
					},
					// {
					// 	title: '赠送总金额(元)',
					// 	key: 'GivenAccount',
					// 	minWidth: 120,
					// },
					{
						title: '会员积分(分)',
						key: 'MemberPoints',
						minWidth: 120,
					},
					// {
					// 	title: '会员等级',
					// 	key: 'MemberLevel',
					// 	minWidth: 100,
					// },
					{
						title: '状态',
						key: 'State',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.StateDesc
							);
						}
					},
					{
						title: '注册时间',
						key: 'CreateTime',
						minWidth: 200,
					},
					// {
					// 	title: '限定场站列表',
					// 	key: 'StationList',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '限定场站列表',
					// 	key: 'StationArray',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '限定运营商列表',
					// 	key: 'OperatorList',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '限定运营商列表',
					// 	key: 'OpeartorArray',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '账户余额',
					// 	key: 'Account',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '累计充值金额',
					// 	key: 'RechargeAccount',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '累计赠送金额',
					// 	key: 'GivenAccount',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '累计赠送金额',
					// 	key: 'GivenAccount',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '创建人',
					// 	key: 'Creator',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '创建时间',
					// 	key: 'CreateTime',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '修改人',
					// 	key: 'Modifier',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '修改时间',
					// 	key: 'ModifyTime',
					// 	minWidth: '150',
					// },
					// {
					// 	title: '是否接受消息推送',
					// 	key: 'IsPushed',
					// 	minWidth: '150',
					// },
					{
						title: '操作',
						key: 'action',
						minWidth: 250,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.openAddGroupMember("up", params.row.GroupId)
								// 		}
								// 	}
								// }, '修改'),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.info({
								// 				title: '注销会员',
								// 				content: '<p>确定注销会员:'+params.row.GroupId+'</p>',
								// 				onOk:() => { this.deleteGroupMember(params.row.GroupId) },
								// 				okText:'注销'
								// 			});

								// 		}
								// 	}
								// }, '注销'),
								this.hasWidgets('recharge') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.openRechangeForGroupMember(params.row.GroupId)
										}
									}
								}, '充值') : h(),
								this.hasWidgets('add') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.openAddChargeCar("add", params.row.GroupId)
										}
									}
								}, '新增充电卡') : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												if (name == '修改') {
													return this.otherMethod(name, params.row.GroupId);
												}
												this.$Modal.confirm({
													title: name,
													okText: '取消',
													cancelText: '确定',
													onCancel: () => {
														this.otherMethod(name, params.row
															.GroupId);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										},
										props: {
											transfer: true,
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, '其他'),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
												item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				methodList: [{
					name: 'blacklist',
					Status: '加入黑名单'
				}, {
					name: 'unBlacklist',
					Status: '解除黑名单'
				}, {
					name: 'edit',
					Status: '修改'
				}],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			VerifyMode1: {
				get() {
					let pay = this.chargeCardInfo.VerifyMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode - 1;
					} else {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode + 1;
					}
				}
			},
			VerifyMode2: {
				get() {
					let pay = this.chargeCardInfo.VerifyMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode - 2;
					} else {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode + 2;
					}
				}
			},
			VerifyMode3: {
				get() {
					let pay = this.chargeCardInfo.VerifyMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(3, 4))
				},
				set(value) {
					if (value == 0) {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode - 4;
					} else {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode + 4;
					}
				}
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})

		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: '集团会员',
					columns: this.columns2,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						k.State = k.StateDesc;
						return k;
					})
				})
			},
			//打开新增会员
			openAddGroupMember: function(type, GroupId) {
				this.$refs.GroupAddMember.openAddGroupMember(type, GroupId)
			},
			otherMethod: function(type, GroupId) {
				const _this = this;
				let status = '-1'
				switch (type) {
					case "加入黑名单":
						status = 1024
						break;
					case "解除黑名单":
						status = 0
						break;
					case "修改":
						let upGroup = _this.data1.filter((item) => {
							return item.GroupId == GroupId
						})
						_this.$refs.GroupAddMember.openAddGroupMember(type, upGroup)
						break;
				}

				if (status == 0 || status == 1024) {
					let parms = {
						Id: GroupId,
						Status: status
					};
					_this.$axios.post(webapi.base_api_url + "/Member/SetMemberStatus ", parms, {}).then(res => {
						if (res.data.Code == 0) {
							_this.$Message.success('黑名单操作成功');
							_this.handleSubmit()
						} else {
							_this.$Message.success('黑名单操作失败');
						}
					})
				}
			},

			//打开新增充电卡
			openAddChargeCar: function(type, GroupId, CardNo) {
				const _this = this;
				if (type == "add") {
					_this.modal2.Title = "充电卡添加";
					_this.modal2.type = "add";
					_this.$refs.chargeCardForm.resetFields()
					_this.chargeCardInfo.GroupId = GroupId
				} else if (type == "up") {
					console.log("打开修改充电卡model")
					_this.modal2.Title = "充电卡修改";
					_this.modal2.type = "up";
					let upGroupMember = _this.data1.filter((item) => {
						return item.GroupId == GroupId
					})
					let upMemberCard = upGroupMember[0].ChargeCards.filter((item) => {
						return item.CardNo == CardNo
					})
					_this.chargeCardInfo = {
						GroupId: upMemberCard[0].GroupId,
						CardNo: upMemberCard[0].CardNo,
						VerifyMode: upMemberCard[0].VerifyMode,
						Password: upMemberCard[0].Password,
						CarNo: upMemberCard[0].CarNo,
						CarVin: upMemberCard[0].CarVin,
						StationList: upMemberCard[0].StationList,
						Remark: upMemberCard[0].Remark,
					};
				}
				_this.modal2.ifShow = true
			},
			//打开集团会员充值
			openRechangeForGroupMember: function(GroupId) {
				this.$refs.GroupDeposit.openRechangeForGroupMember(GroupId)
			},
			//model2操作
			modalOk2: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal2.ifShow = false
						break;
					case 'add':
						_this.modal2.ifShow = true
						_this.addCard();
						break;
					case 'up':
						_this.modal2.ifShow = true
						_this.upCard();
						break;
					default:
						break;
				}
			},
			//添加卡
			addCard: function() {
				const _this = this;
				_this.$refs.chargeCardForm.validate((valid) => {
					if (valid) {
						_this.chargeCardInfo.StationList = JSON.stringify(_this.chargeCardInfo.StationArray)
						let parms = _this.chargeCardInfo
						_this.$axios.post(webapi.base_api_url + "/Member/AddChargeCard", parms, {}).then(
							res => {
								console.log("新增卡")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success('添加卡成功');
									_this.handleSubmit();
									_this.modalOk2("cancle")
								} else {
									this.$Message.success(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
			//修改卡
			upCard: function() {
				const _this = this;
				_this.chargeCardInfo.StationList = JSON.stringify(_this.chargeCardInfo.StationArray)
				let parms = _this.chargeCardInfo
				_this.$axios.post(webapi.base_api_url + "/Member/ModifyChargeCard", parms, {}).then(res => {
					console.log("修改卡")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('修改卡成功');
						_this.handleSubmit();
						_this.modalOk2("cancle")
					} else {
						this.$Message.success(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//操作
			show: function(type, params) {
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
	.tableExtend td.ivu-table-expanded-cell {
		padding: 1px 60px;
		background: #f8f8f9;
	}

	.tableExtend {
		width: 100%;
	}
</style>
